import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PhotoAlbum from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/captions.css';

import { getGalleryModuleDefaultLang } from 'shared/lib/contentModules';
import {
  galleryOwnerPropTypes,
  galleryPhotoPublicPropTypes,
  galleryPhotoOwnerPropTypes,
} from 'shared/proptypes/ContentModule';
import { STATIC_BASE_URL } from 'shared/routes';

const ContentModulePhotoAlbum = ({ photos, display, margin, langVersion }) => {
  const [index, setIndex] = useState(-1);

  const isOwnerView = !!langVersion;
  const defaultLang = isOwnerView
    ? getGalleryModuleDefaultLang({ photos })
    : null;

  const galleryPhotos = photos.map(photo => ({
    key: photo.id,
    src: `${STATIC_BASE_URL}${photo.src}`,
    description: isOwnerView
      ? (photo.description[langVersion] || photo.description[defaultLang])
      : photo.description,
    width: photo.width,
    height: photo.height,
  }));

  const handlePhotoClick = (event, photo, id) => setIndex(id);

  return (
    <>
      <PhotoAlbum
        photos={galleryPhotos}
        layout={display}
        spacing={margin}
        onClick={handlePhotoClick}
      />
      <Lightbox
        slides={galleryPhotos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Captions, Fullscreen, Thumbnails, Zoom]}
      />
    </>
  );
};

ContentModulePhotoAlbum.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(galleryPhotoPublicPropTypes),
    PropTypes.shape(galleryPhotoOwnerPropTypes),
  ])).isRequired,

  display: galleryOwnerPropTypes.display,

  margin: galleryOwnerPropTypes.margin,
  langVersion: PropTypes.string,
};

ContentModulePhotoAlbum.defaultProps = {
  langVersion: null,
};

export default ContentModulePhotoAlbum;
